import { render, staticRenderFns } from "./own.vue?vue&type=template&id=565426fa&scoped=true&"
import script from "./own.vue?vue&type=script&lang=js&"
export * from "./own.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565426fa",
  null
  
)

export default component.exports